// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_fjL-S","foot_link":"index_foot_link_hniTu clearfix","fk_l":"index_fk_l_petAH","link":"index_link_70v33","copyright":"index_copyright_hZjuH"};